import React, { useState } from 'react';
import Category from "./Category";
import Loader from "./Loader";
import Masonry from "react-masonry-css";
import { useInfiniteQuery } from 'react-query';
import { useGlobalContext } from '../Context';
import { useNavigate } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingText from './LoadingText';

const API_URL = process.env.REACT_APP_API_URL || "https://mememama-i0ol.onrender.com";

const thumb = (url) =>
  url ? url.replace("/upload/", "/upload/w_400,f_auto,q_auto/") : url;

const InfiniteScrl = () => {
  const navigate = useNavigate();
  const { handleImageClick } = useGlobalContext();
  const [cat, setCat] = useState("");

  const handleCatSelect = (e) => {
    setCat(e.target.value);
  };

  const fetchImages = async ({ pageParam = null }) => {
    const base = cat ? `${API_URL}/${cat}` : `${API_URL}/allImages`;
    const url = pageParam
      ? `${base}?cursor=${encodeURIComponent(pageParam)}`
      : base;

    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to load templates");
    return response.json();
  };

  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery(
    ["images", cat],
    fetchImages,
    {
      getNextPageParam: (lastPage) => lastPage.nextCursor ?? false,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 60 * 24,
    }
  );

  const allImages = data?.pages?.flatMap((page) => page.items) ?? [];

  const thumbnails = allImages.map((img) => (
    <div
      key={img._id}
      className="img-div"
      onClick={() => navigate(`/template/${img._id}`)}
    >
      <img
        className="fetchedImages"
        src={thumb(img.imageUrl)}
        alt="meme-template"
        style={{ aspectRatio: `${img.width} / ${img.height}` }}
        onClick={() => handleImageClick(img)}
        loading="lazy"
      />
    </div>
  ));

  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    800: 1,
  };

  return (
    <>
    {isLoading ? (
      <div className="pageLoading">
        <Loader />
      </div>
    ) : (
      <>
        <Category handleCatSelect={handleCatSelect} cat={cat} />
        <InfiniteScroll
          dataLength={allImages.length}
          next={fetchNextPage}
          hasMore={!!hasNextPage}
          loader={<LoadingText />}
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>All templates loaded. </b>
            </p>
          }
        >
          <div className="itemsDiv">
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              {thumbnails}
            </Masonry>
          </div>
        </InfiniteScroll>
      </>
    )}
  </>
  );
};

export default InfiniteScrl;